const LockedIcon = () => {
  return (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 41 40"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3307_6415)">
        <ellipse cx="20.0389" cy="20" fill="white" rx="14.0389" ry="14" />
      </g>
      <path
        d="M23.4626 16.9618V16.074C23.4626 14.2847 22.004 12.8301 20.2097 12.8301C18.4155 12.8301 16.9568 14.2847 16.9568 16.074V16.9618C15.6283 17.1393 14.9023 18.0135 14.9023 19.4886V23.5862C14.9023 25.2389 15.8132 26.1472 17.4704 26.1472H22.949C24.6063 26.1472 25.5171 25.2389 25.5171 23.5862V19.4886C25.5171 18.0203 24.7912 17.1393 23.4626 16.9618ZM20.2097 13.8545C21.4356 13.8545 22.4354 14.8515 22.4354 16.074V16.9276H17.9841V16.074C17.9841 14.8515 18.9839 13.8545 20.2097 13.8545ZM24.4899 23.5862C24.4899 24.6652 24.031 25.1228 22.949 25.1228H17.4704C16.3884 25.1228 15.9296 24.6652 15.9296 23.5862V19.4886C15.9296 18.4096 16.3884 17.952 17.4704 17.952H22.949C24.031 17.952 24.4899 18.4096 24.4899 19.4886V23.5862ZM21.0795 20.8545C21.0795 21.1345 20.9356 21.3735 20.7233 21.5306V22.9032C20.7233 23.1832 20.4905 23.4154 20.2097 23.4154C19.929 23.4154 19.6961 23.1832 19.6961 22.9032V21.5101C19.4975 21.353 19.3605 21.1208 19.3605 20.8545C19.3605 20.3832 19.7372 20.0008 20.2166 20.0008C20.6891 20.0008 21.0726 20.3832 21.0726 20.8545H21.0795Z"
        fill="#8B8B8B"
      />
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="40"
          id="filter0_d_3307_6415"
          width="40.0779"
          x="0"
          y="0"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1"
            result="effect1_dropShadow_3307_6415"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_3307_6415"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_3307_6415"
            mode="normal"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LockedIcon;
